module.exports = __webpack_public_path__ + "static/logo-c51d79fda620f1bb3938f6c479237d3d.png";